import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LanguageSkillItem = _resolveComponent("LanguageSkillItem")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!

  return (_openBlock(), _createElementBlock("div", null, [
    (_ctx.languguageSkills && _ctx.languguageSkills.length)
      ? (_openBlock(), _createBlock(_component_v_row, {
          key: 0,
          class: "pt-6"
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.languguageSkills, (item, index) => {
              return (_openBlock(), _createBlock(_component_v_col, {
                lg: "6",
                cols: "12",
                key: 'row_' + index
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_LanguageSkillItem, {
                    language: item,
                    isHiringmanager: _ctx.isHiringmanager,
                    loading: _ctx.loading,
                    onEdit: ($event: any) => (_ctx.edit(item)),
                    onRemove: ($event: any) => (_ctx.remove(item))
                  }, null, 8, ["language", "isHiringmanager", "loading", "onEdit", "onRemove"])
                ]),
                _: 2
              }, 1024))
            }), 128))
          ]),
          _: 1
        }))
      : _createCommentVNode("", true)
  ]))
}